import axios from "axios";
import { Api } from "../api";

const ContentRepository = {
 /**
     * getContent
     * 
     * @param {String} uri
     * @returns {Object} server response
     */  
    async getContent(uri : String) {
        try{
            const res = await axios.get(Api.BACKEND_URL + Api.CONTENT_URI + uri)
            console.log('getContent res', res)
            return res
        } catch (e){
            console.log('getContent error',e);
            return {};
        }
   },

}

export default ContentRepository;